import { render } from "./PortfolioThompson.vue?vue&type=template&id=c3f3b3da"
import script from "./PortfolioThompson.vue?vue&type=script&lang=js"
export * from "./PortfolioThompson.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__